import { AxiosError } from 'axios';
import { ApiError } from '../../types/ApiTypes';

export const getApiErrorMessage = (err: AxiosError) => {
  const errorData = err.response?.data as ApiError;
  const errorMessage = errorData.messageForUser;

  return errorMessage;
};
